module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0069.jpg?v=9bae763d";